import { platformMyDayHostCapability, platformMyDayHostSlots, } from '@crest/platform-contracts/hosts';
import { schedulingModuleManifest } from '../scheduling.module.js';
import { schedulingSettingRegistrations } from '../settings/scheduling-setting-definitions.js';
export const schedulingWebModuleContribution = {
    moduleId: 'scheduling',
    manifest: schedulingModuleManifest,
    settingRegistrations: schedulingSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [{
            id: 'scheduling.web.platform.my-day',
            moduleId: 'scheduling',
            slot: platformMyDayHostSlots.primary,
            contractVersion: platformMyDayHostCapability,
            requiredPermission: 'scheduling.events.read',
            settingCondition: null,
            priority: 15,
            errorBehavior: 'inline',
            emptyBehavior: 'collapse',
            load: () => import('./scheduling-my-day.panel.js'),
        }],
    routes: [{
            id: 'scheduling.web.events',
            moduleId: 'scheduling',
            path: '/dispatch',
            requiredPermission: 'scheduling.events.read',
            navigation: {
                id: 'scheduling.navigation.events',
                fallbackLabel: 'Schedule & Dispatch',
                labelConfigurationKey: 'scheduling.copy.events',
                labelValueProperty: 'navigationLabel',
                priority: 40,
            },
            load: () => import('./scheduling-events.page.js'),
        }],
};
export default schedulingWebModuleContribution;
//# sourceMappingURL=scheduling-web.module-contribution.js.map